import React, { useEffect, useCallback } from 'react';
import CookieConsent, { getCookieConsentValue } from 'react-cookie-consent';
import { loadMouseflow, loadAnalytics, loadMixpanel, loadNewRelicBrowser } from '../tracking/loaders';
import { Typography, Link, Button } from '@mui/material';
import { USER_PILOT_TOKEN } from 'config';
import { Userpilot } from 'userpilot';

const CONSENT_COOKIE_NAME = 'CookieConsent';
const COOKIE_EXPIRES_DAYS = 365;

async function loadAllTrackers() {
  Userpilot.initialize(USER_PILOT_TOKEN);
  await Promise.allSettled([loadMouseflow(), loadNewRelicBrowser(), loadAnalytics(), loadMixpanel()]);
}

export const CookieConsentManager = () => {
  useEffect(() => {
    /*     const value = getCookieConsentValue(CONSENT_COOKIE_NAME);
    if (value === 'true') {
      loadAllTrackers();
    } */
    loadAllTrackers();
  }, []);

  const handleAccept = useCallback(() => {
    loadAllTrackers();
  }, []);

  const handleDecline = useCallback(() => {}, []);

  // We decided to revert the cookie consent banner for now, but it will be re-enabled in future, so keep all the logic
  return null;

  return (
    <>
      <CookieConsent
        enableDeclineButton
        buttonText="Accept"
        declineButtonText="Decline"
        expires={COOKIE_EXPIRES_DAYS}
        cookieName={CONSENT_COOKIE_NAME}
        onAccept={handleAccept}
        onDecline={handleDecline}
        containerClasses="cookie-banner"
        style={{ zIndex: 9999 }}
        ButtonComponent={Button}
        customButtonProps={{
          style: {
            marginRight: '10px',
          },
          variant: 'contained',
        }}
        customDeclineButtonProps={{
          style: {
            marginRight: '10px',
            backgroundColor: 'white',
          },
          variant: 'outlined',
        }}
        disableButtonStyles
      >
        <Typography variant="body1" component="span">
          This website uses cookies to enhance the user experience.
        </Typography>{' '}
        <Link href="https://trnsact.com/privacy-policy/" target="_blank" fontWeight="bold">
          Privacy Policy
        </Link>
      </CookieConsent>
    </>
  );
};
